import { makeResource, mapped } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('mediaOwners/features', {
  resource () {
    return {
      id: mapped(null),
      name: mapped(null),
      key: mapped(null),
      description: mapped(null),
      enabled: mapped(false),
    }
  }
})
